import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate, useOutletContext, useParams } from "react-router";
import { useMediaQuery } from "react-responsive";

import OrderGroup from "../common/orderGroup";
import SectionHeader from "../common/sectionTitle";

import { OrderDetailContainer } from "./styled";
import { FaChevronLeft } from "react-icons/fa6";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CancelModal from "./orderHistory/cancelModal";

const OrderDetail = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const { url, openModal, closeModal } = useOutletContext();
  const user = useSelector((state) => state?.user?.data[0]);
  const [orderData, setOrderData] = useState(null);
  const [dialogType, setDialogType] = useState("");

  useEffect(() => {
    getOrder();
  }, []);

  const getOrder = async () => {
    const url = "/erp/customerOrder/get";
    const body = { id: orderId };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        const data = res.data;
        if (data.mberNo !== user?.mberNo) {
          throw new Error("잘못된 접근");
        }
        console.log(data);
        setOrderData(data);
      }
    } catch (error) {
      console.log(error);
      toast.error("잘못된 접근입니다.");
      navigate("/shop/mypage/history");
    }
  };

  const InfoSection = ({ title, items }) => {
    return (
      <div className="section">
        <span className="label">{title}</span>
        <ul>
          {items.map((item, i) => (
            <li key={i} className={item.highlight ? "highlight" : ""}>
              <span>{item.label}</span>
              <span>{item.value}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const toggleModal = (item = null, type = "") => {
    // setSelection(item);
    setDialogType(type);
  };

  const getModal = () => {
    switch (dialogType) {
      case "cancel":
        return (
          <CancelModal
            toggleModal={toggleModal}
            selection={orderData?.subOrders[0]}
            openModal={openModal}
            closeModal={closeModal}
            getData={getOrder}
          />
        );
    }
  };

  if (!orderData) return null;
  const isCancelled = Boolean(orderData.payment.cancelledAt);

  return (
    <OrderDetailContainer>
      {dialogType && getModal()}
      <h2>
        {isMobile && (
          <button onClick={() => navigate(`/shop/mypage/history`)}>
            <FaChevronLeft />
          </button>
        )}
        <span>주문 상세 정보</span>
      </h2>
      <SectionHeader title="주문 상품 정보" withLine />
      <div className="contents">
        <div className="section">
          <OrderGroup
            isDetail={true}
            item={orderData}
            openModal={openModal}
            closeModal={closeModal}
            toggleModal={toggleModal}
          />
        </div>
        <InfoSection
          title="받는 사람 정보"
          items={[
            { label: "받는 사람", value: orderData.receiverName },
            { label: "연락처", value: orderData.receiverTel },
            { label: "주소", value: `${orderData.address}, ${orderData.addressDetail}` },
            { label: "배송요청사항", value: orderData?.subOrders?.[0]?.memo },
          ]}
        />
        <InfoSection
          title="결제 정보"
          items={[
            { label: "결제 수단", value: orderData.payment.paymentMethod },
            { label: "총 상품 가격", value: `${orderData.totalPrice.toLocaleString()}원` },
            { label: "할인 금액", value: `${orderData.discount.toLocaleString()}원` },
            { label: "배송비", value: `${orderData.deliveryFee.toLocaleString()}원` },
            {
              label: isCancelled ? "결제 금액" : "총 결제 금액",
              value: `${orderData.finalPrice.toLocaleString()}원`,
              highlight: true,
            },
            ...(isCancelled
              ? [
                  {
                    label: "취소 일시",
                    value: moment(orderData.payment.cancelledAt).format("YYYY.MM.DD HH:mm"),
                  },
                  { label: "취소 사유", value: orderData.payment.cancelReason },
                  orderData.payment.refundedAmount && {
                    label: "환불 금액",
                    value: `${orderData.payment.refundedAmount.toLocaleString()}원`,
                    highlight: true,
                  },
                ].filter(Boolean)
              : []),
          ]}
        />
      </div>
    </OrderDetailContainer>
  );
};

export default OrderDetail;
